import React from 'react';
import { Title, Description, Image } from '../../components/layouts';
import './style.scss';
import { buildImageURL, getTrack } from '../../helpers';

const IMG = buildImageURL('/night-brief.jpg');

const track = getTrack({ block: 7 });

export function CameraNightBrief({ mobile = false }) {

  return (
    <div className="page-section section-camera-night-brief inverted" data-track={track}>
      <div className="section-content title center">
        {/*{!mobile && <Image src={IMG} />}*/}
        <Title>全场景超级夜景</Title>
        {/*{!mobile && <Description>超级组合，带来超震撼捕捉，X60 Pro+搭载vivo蔡司联合影像系统，复原本真之美，带来专业影像期间，让视觉质感更进一层，从此刷新感官新境。</Description>}*/}
      </div>
    </div>
  );
}
